export const reducerSetSearchExerciseFolder = (state, {folder}) => {
    return {
        ...state,
        filters: {
            ...state.filters,
            exerciseFolder: folder,
        },
    };
}